import { Activity } from 'lucide-react';

const style = {
  wrapper: {
    display:        'flex',
    flexDirection:  'column',
    alignItems:     'center',
    justifyContent: 'center',
    minHeight:      '60vh',
    gap:            '1rem',
    color:          'var(--text-secondary)',
  },
  icon: {
    color: 'var(--accent-light)',
    animation: 'pulse-dot 1.5s ease-in-out infinite',
  },
  text: {
    fontSize:   '0.9rem',
    letterSpacing: '0.04em',
  },
};

function LoadingScreen() {
  return (
    <div style={style.wrapper}>
      <Activity size={32} style={style.icon} />
      <p style={style.text}>Chargement des données…</p>
    </div>
  );
}

export default LoadingScreen;
